<template>
  <div class="footer siteMap mt-5">
    <div class="container-fluid">
      <div class="row">
        <h6 class="p-5 show-hyperlinks" v-html="$t('footer.description')">
        </h6>
        <hr>
      </div>
      <div class="row p-3">
        <div class="col-md-4">
          <ul>
            <li><b>{{ $t('footer.flatpriveRooms') }}</b></li>
            <li v-if="es"><a href="/alquiler-habitacion-leon?showAll=true&type=room">{{ $t('footer.rentRooms') }}</a>
            </li>
            <li v-if="!es"><a href="/en/room-rental-leon?showAll=true&type=room">{{ $t('footer.rentRooms') }}</a></li>
            <li v-if="es"><a href="/alquiler-habitacion-leon?showAll=true&type=room">{{
                $t('footer.rentSharedApartments')
              }}</a></li>
            <li v-if="!es"><a
                href="/en/room-rental-leon?showAll=true&type=room">{{ $t('footer.rentSharedApartments') }}</a></li>
            <li v-if="es"><a
                href="/alquiler-habitacion-leon?showAll=true&type=room">{{ $t('footer.rentColiving') }}</a>
            </li>
            <li v-if="!es"><a
                href="/en/room-rental-leon?showAll=true&type=room">{{ $t('footer.rentColiving') }}</a>
            </li>
            <li v-if="es"><a
                href="/alquiler-habitacion-leon?showAll=true&type=room">{{ $t('footer.rentStudentApartment') }}</a>
            </li>
            <li v-if="!es"><a href="/en/room-rental-leon?showAll=true&type=room">{{ $t('footer.rentStudentApartment') }}</a>
            </li>
            <li v-if="es"><a
                href="/alquiler-habitacion-leon?showAll=true&type=room">{{ $t('footer.rentSharedApartments2') }}</a>
            </li>
            <li v-if="!es"><a href="/en/room-rental-leon?showAll=true&type=room">{{
                $t('footer.rentSharedApartments2')
              }}</a></li>
            <li v-if="!es"><a
                href="/en/room-rental-leon?showAll=true&type=room">{{ $t('footer.rentStudents') }}</a></li>
            <li v-if="es"><a
                href="/alquiler-habitacion-leon?showAll=true&type=room">{{ $t('footer.rentStudents') }}</a>
            </li>
            <li v-if="!es"><a
                href="/en/room-rental-leon?showAll=true&type=room">{{ $t('footer.rentStudentsRooms') }}</a></li>
            <li v-if="es"><a
                href="/alquiler-habitacion-leon?showAll=true&type=room">{{ $t('footer.rentStudentsRooms') }}</a>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul>
            <li><b>{{ $t('footer.flatpriveApartments') }}</b></li>
            <li v-if="es"><a href="/alquiler-piso-leon?showAll=true&type=apartment">{{ $t('footer.rentApartment') }}</a>
            </li>
            <li v-if="!es"><a href="/en/apartment-rental-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartment')
              }}</a></li>
            <li v-if="es"><a href="/alquiler-piso-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon')
              }}</a></li>
            <li v-if="!es"><a href="/en/apartment-rental-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon')
              }}</a></li>
            <li v-if="es"><a href="/alquiler-piso-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon2')
              }}</a></li>
            <li v-if="!es"><a href="/en/apartment-rental-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon2')
              }}</a></li>
            <li v-if="es"><a href="/alquiler-piso-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon3')
              }}</a></li>
            <li v-if="!es"><a href="/en/apartment-rental-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon3')
              }}</a></li>
            <li v-if="es"><a href="/alquiler-piso-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon4')
              }}</a></li>
            <li v-if="!es"><a href="/en/apartment-rental-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon4')
              }}</a></li>
            <li v-if="es"><a href="/alquiler-piso-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon5')
              }}</a></li>
            <li v-if="!es"><a href="/en/apartment-rental-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon5')
              }}</a></li>
            <li v-if="es"><a href="/alquiler-piso-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon6')
              }}</a></li>
            <li v-if="!es"><a href="/en/apartment-rental-leon?showAll=true&type=apartment">{{
                $t('footer.rentApartmentLeon6')
              }}</a></li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul>
            <li><b>{{ $t('footer.contact') }}</b></li>
            <li v-if="es"><a href="/preguntas-frecuentes">{{ $t('footer.faqs') }}</a></li>
            <li v-if="!es"><a href="/en/faq">{{ $t('footer.faqs') }}</a></li>
            <li v-if="es"><a href="/contacto">{{ $t('footer.contactUs') }}</a></li>
            <li v-if="!es"><a href="/en/contact">{{ $t('footer.contactUs') }}</a></li>
            <li><a href="mailto:info@flatprive.com">info@flatprive.com</a></li>
            <li v-if="es"><a href="/sobre-nosotros">{{ $t('footer.aboutUs') }}</a></li>
            <li v-if="!es"><a href="/en/about-us">{{ $t('footer.aboutUs') }}</a></li>
          </ul>
        </div>
      </div>
      <div class="text-center row rrss">
        <a href="https://www.linkedin.com/company/flatprive" target="_blank"><i class="bi bi-linkedin"></i></a>
        <a href="https://x.com/flatprive" target="_blank"><i class="bi bi-twitter-x"></i></a>
        <a href="https://www.facebook.com/flatprive/" target="_blank"><i class="bi bi-facebook"></i></a>
        <a href="https://www.instagram.com/flatprive/" target="_blank"><i class="bi bi-instagram"></i></a>
        <a href="https://www.tiktok.com/@flatprive" target="_blank"><i class="bi bi-tiktok"></i></a>
      </div>
      <div class="text-center p-5">
        <img :src="require('@/assets/img/logoFooter_2.png')" alt="Logo" width="auto" height="60">
        <br>
        <div class="mt-3">
          <small>{{ $t("footer.terms") }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {}
  },
  computed: {
    es() {
      return this.$i18n.locale === 'es';
    }
  }
}
</script>